export default __webpack_public_path__ + "static/media/list-view-icon.3c2a4d6c.svg";